var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-container" }, [
    !_vm.loading
      ? _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "mb-3" }, [
            _c("div", { staticClass: "header-section" }, [
              _c(
                "div",
                { staticClass: "has-text-weight-semibold is-size-6 mb-5" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.getTypeDisplayName(_vm.selectedType)) +
                      " zone - " +
                      _vm._s(_vm.currentRegion || "") +
                      " "
                  ),
                ]
              ),
              _c("div", { staticClass: "type-selector" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select is-small" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedType,
                              expression: "selectedType",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedType = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        _vm._l(_vm.availableShapeTypes, function (type) {
                          return _c(
                            "option",
                            {
                              key: type.value,
                              domProps: { value: type.value },
                            },
                            [_vm._v(" " + _vm._s(type.label) + " ")]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "has-text-danger has-text-weight-semibold is-size-7 mb-2",
              },
              [_vm._v(" " + _vm._s(_vm.msg) + " ")]
            ),
            _vm.selectedType === "geofence"
              ? _c("div", [
                  _c("div", { staticClass: "field mb-2 mt-3" }, [
                    _c("div", { staticClass: "field has-addons" }, [
                      _c(
                        "div",
                        { staticClass: "control is-expanded" },
                        [
                          _c("GlobalSelector", {
                            attrs: {
                              label: "Distribution Zone",
                              type: "single",
                              dataSource: "hubs",
                              placeholder: "Select a distribution zone...",
                              disabled: false,
                            },
                            model: {
                              value: _vm.selectedHub,
                              callback: function ($$v) {
                                _vm.selectedHub = $$v
                              },
                              expression: "selectedHub",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "field mt-3 days-of-service" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "label is-size-7 has-text-weight-semibold mb-2",
                      },
                      [_vm._v("Days of Service")]
                    ),
                    _c(
                      "div",
                      { staticClass: "days-container" },
                      _vm._l(_vm.daysOfService, function (day, key) {
                        return _c(
                          "label",
                          { key: key, staticClass: "checkbox" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.daysOfService[key],
                                  expression: "daysOfService[key]",
                                },
                              ],
                              staticClass: "mr-1",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.daysOfService[key])
                                  ? _vm._i(_vm.daysOfService[key], null) > -1
                                  : _vm.daysOfService[key],
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.daysOfService[key],
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.daysOfService,
                                          key,
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.daysOfService,
                                          key,
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.daysOfService, key, $$c)
                                  }
                                },
                              },
                            }),
                            _vm._v(" " + _vm._s(_vm.getDayLabel(key)) + " "),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c("div", { staticClass: "field mt-3" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "label is-size-7 has-text-weight-semibold mb-2",
                      },
                      [_vm._v("Shape Color")]
                    ),
                    _c("div", { staticClass: "color-input-container" }, [
                      _c("div", { staticClass: "color-picker-wrapper" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedColor,
                              expression: "selectedColor",
                            },
                          ],
                          staticClass: "color-picker",
                          attrs: { type: "color" },
                          domProps: { value: _vm.selectedColor },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.selectedColor = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.selectedType === "billable"
              ? _c("div", [
                  _c("div", { staticClass: "field mb-2" }, [
                    _c("div", { staticClass: "field has-addons" }, [
                      _c(
                        "div",
                        { staticClass: "control is-expanded" },
                        [
                          _c("GlobalSelector", {
                            attrs: {
                              label: "Zone",
                              type: "single",
                              dataSource: "zones",
                              placeholder: "Select a zone...",
                              disabled: false,
                              zoneType: "billable",
                            },
                            model: {
                              value: _vm.zone,
                              callback: function ($$v) {
                                _vm.zone = $$v
                              },
                              expression: "zone",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm.zone?.value
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-flex-direction-column is-flex-wrap-wrap is-align-items-baseline mt-1 mb-1",
                        },
                        [
                          _c("GlobalSelector", {
                            attrs: {
                              label: "Clients",
                              type: "multi",
                              dataSource: "clients",
                              placeholder: "Select clients...",
                              disabled: true,
                            },
                            model: {
                              value: _vm.selectedClients,
                              callback: function ($$v) {
                                _vm.selectedClients = $$v
                              },
                              expression: "selectedClients",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.selectedType === "payable"
              ? _c("div", [
                  _c("div", { staticClass: "field mb-2" }, [
                    _c("div", { staticClass: "field has-addons" }, [
                      _c(
                        "div",
                        { staticClass: "control is-expanded" },
                        [
                          _c("GlobalSelector", {
                            attrs: {
                              label: "Zone",
                              type: "single",
                              dataSource: "zones",
                              placeholder: "Select a zone...",
                              disabled: false,
                              zoneType: "payable",
                            },
                            model: {
                              value: _vm.zone,
                              callback: function ($$v) {
                                _vm.zone = $$v
                              },
                              expression: "zone",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm.zone?.value
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-flex-direction-column is-flex-wrap-wrap is-align-items-baseline mt-1 mb-1",
                        },
                        [
                          _c("GlobalSelector", {
                            attrs: {
                              label: "Contractors",
                              type: "multi",
                              dataSource: "contractors",
                              placeholder: "Select contractors...",
                              disabled: true,
                            },
                            model: {
                              value: _vm.selectedContractors,
                              callback: function ($$v) {
                                _vm.selectedContractors = $$v
                              },
                              expression: "selectedContractors",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "buttons-container" }, [
            _c("div", { staticClass: "buttons is-centered" }, [
              _c(
                "button",
                {
                  staticClass: "button is-small",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "button",
                {
                  staticClass: "button is-small is-success",
                  on: { click: _vm.saveToFirestore },
                },
                [_vm._v("Save")]
              ),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "loader-container" }, [_c("PulseLoader")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }